const NEWSLETTERS_SECTION_TEST_IDS = {
  CAROUSEL_HERO_WRAPPER: 'carousel-hero-wrapper',
  CATEGORY_LIST: 'category-list',
  CATEGORY_TITLE: 'category-title',
  CATEGORY_WRAPPER: 'category-wrapper',
  CREATE_ACCOUNT: 'create-free-account',
  NEWSLETTERS: 'newsletters',
  NEWSLETTERS_BACK_BUTTON: 'newsletters-back-button',
  NEWSLETTERS_CAROUSEL: 'newsletters-carousel',
  NEWSLETTERS_DESCRIPTION: 'newsletters-description',
  NEWSLETTERS_LOGO: 'newsletters-logo',
  NEWSLETTERS_MODAL: 'newsletters-error-modal',
  NEWSLETTERS_STICKY: 'newsletters-sticky-header',
  NEWSLETTERS_SUBTITLE: 'newsletters-subtitle',
  NEWSLETTERS_WRAPPER: 'newsletters-wrapper',
  NEWSLETTER_CARD: 'newsletter-card',
  NEWSLETTER_CARD_AUTHORS: 'newsletter-card-authors',
  NEWSLETTER_CARD_AUTHORS_LINE: 'newsletter-card-authors-line',
  NEWSLETTER_CARD_DESCRIPTION: 'newsletter-card-description',
  NEWSLETTER_CARD_FREQUENCY: 'newsletter-card-frequency',
  NEWSLETTER_CARD_ICON: 'newsletter-card-icon',
  NEWSLETTER_CARD_SUBSCRIBE_SECTION: 'newsletter-card-subscribe-section',
  NEWSLETTER_CARD_SUBSCRIBE_SECTION_BUTTON: 'newsletter-card-subscribe-section-button',
  NEWSLETTER_CARD_SUBSCRIBE_SECTION_LINK: 'newsletter-card-subscribe-section-link',
  NEWSLETTER_CARD_TITLE: 'newsletter-card-title',
  NEWSLETTER_CARD_WRAPPER: 'newsletter-card-wrapper',
  NEWSLETTER_HERO: 'newsletter-hero',
  NEWSLETTER_SUBSCRIPTIONS_TITLE: 'newsletter-subscription-title',
  SLIDER_STICK: 'slider-stick',
  SLIDER_WRAPPER: 'slider-wrapper',
  SUBSCRIBE_TO_ALL: 'subscribe-to-all',
  SUBSCRIPTIONS_LIST: 'subscriptions-list',
  SUBSCRIPTIONS_PLEA: 'subscriptions-plea',
  SUBSCRIPTIONS_PLEA_LINK: 'subscriptions-plea-link',
  SUBSCRIPTIONS_TITLE: 'subscriptions-title',
  SUBSCRIPTIONS_WRAPPER: 'subscriptions-wrapper',
  UNSUBSCRIBE_ALL: 'usubscribe-all',
};

export default NEWSLETTERS_SECTION_TEST_IDS;
